module.exports = __webpack_public_path__ + "static/img/logoTwo.161fe2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageTwo/logoTwo.png
// module id = mdti
// module chunks = 0